export default [
  {
    platform: 'Aceptado',
    agency: 'No existe',
    action: 'Reenviar a SII',
    counter: 'axt_count'
  },
  {
    platform: 'No existe',
    agency: 'Aceptado',
    action: 'Revisar Documentos',
    counter: 'client_count'
  },
  {
    platform: 'Rechazado / Pendiente',
    agency: 'Aceptado',
    action: 'Actualizar TrackID y Revalidar',
    counter: 'failed_count'
  }
]
